import { render } from "./FavoritesMenu.vue?vue&type=template&id=1bb59d16&scoped=true"
import script from "./FavoritesMenu.vue?vue&type=script&lang=js"
export * from "./FavoritesMenu.vue?vue&type=script&lang=js"

import "./FavoritesMenu.vue?vue&type=style&index=0&id=1bb59d16&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bb59d16"]])

export default __exports__